import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TriangleDownIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 14.5L16.5 9.5H7.5L12 14.5Z'
                fill='currentColor'
            />
        </>
    ),
})

TriangleDownIcon.displayName = 'TriangleDownIcon'
